import React, { useContext, Fragment } from 'react';
import { withStyles, Divider, Grid } from '@material-ui/core';
import Carousel from '../../carousel/Carousel';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';
// import IconMorePressed from "../../../asset/img/btn_more_sel.png";
import IconMore from '../../../asset/img/btn_more_nor.svg';
import IconInfo from '../../../asset/img/ico_info_black.svg';
// import IconCons from "../../../asset/img/footer_ico_consulting.svg"
// import IconConsStore from "../../../asset/img/footer_ico_consulting_store.svg"

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '0.375rem 0rem',
    zIndex: 10,
  },
  carousel: {
    width: '100%',
    height: '9rem',
  },
  listitem: {
    width: '16.625rem',
    padding: '0rem',
    display: 'flex',
    margin: '0 0 0.375rem 0',
  },
  card: {
    width: '16.25rem',
    height: '100%',
    flex: 'auto',
    background: '#fff',
    border: '0.0625rem solid #d7d7d7',
    borderRadius: '0.375rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 0.375rem 0 0',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  badgeBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // margin: "0.75rem"
  },
  badgeItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '1.25rem',
    borderRadius: '0.25rem',
    fontWeight: 'bold',
    fontSize: theme.font.size11,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1',
    letterSpacing: 'normal',
    margin: '0 0.25rem 0 0',
    padding: '0 0.375rem',
    width: 'max-content',
  },
  badgeItemRed: {
    background: theme.color.badge.bg_red,
    color: theme.color.badge.text_red,
  },
  badgeItemPupple: {
    background: theme.color.badge.bg_pupple,
    color: theme.color.badge.text_pupple,
  },
  badgeItemGreen: {
    background: theme.color.badge.bg_green,
    color: theme.color.badge.text_green,
  },
  badgeItemGrey: {
    background: theme.color.badge.bg_grey,
    color: theme.color.badge.text_grey,
  },
  moreItemList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '18.75rem',
    padding: '0rem 0rem 0rem 0.5rem',
  },
  moreItemCard: {
    width: '8.75rem',
    background: 'transparent',
    border: '0rem',
    borderRadius: '0.375rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  moreItemText: {
    fontSize: theme.font.size13,
    fontWeight: 'normal',
    color: theme.color.text,
    textAlign: 'center',
    margin: '0.9375rem 0rem',
    lineHeight: '1.46',
  },
  thumbnail: {
    height: '9.75rem',
    padding: '1rem 0 0 0',
    margin: '0 0 0.5rem 0',
    background: 'none',
    border: 'none',
  },
  thumbnailImage: {
    width: 'auto',
    height: '8.75rem',
  },
  moreItemThumbnailImage: {
    width: '3.75rem',
    height: '3.75rem',
    backgroundImage: `url(${IconMore})`,
    backgroundSize: '3.75rem',
    // "&:active": {
    //   backgroundImage: `url(${IconMorePressed})`,
    // },
  },
  info: {
    flexGrow: 1,
    minHeight: '9.688rem',
  },
  infoTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: theme.font.size16, // "0.9375rem",
    fontWeight: 'bold',
    color: theme.color.text_color.black,
    textAlign: 'left',
    padding: '0rem 1.25rem',
    minHeight: '2.875rem',
    lineHeight: '1.38',
  },
  infoDescription: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    color: theme.color.text_color.grey,
    padding: '0rem 1.25rem',
    // margin: "0 0 0.7813rem 0"
    // textAlign: "center",
  },
  horizontalDivider: {
    width: 'auto',
    height: '0.0625rem',
    backgroundColor: theme.color.divider.grey,
    margin: '0.7188rem 1.25rem',
  },
  table: {
    width: '-webkit-fill-available',
    margin: '0 1.25rem',
    padding: '0rem',
  },
  tableRow: {
    height: '100%',
    display: 'flex',
    alignItems: 'baseline',
  },
  label: {
    height: '100%',
    minHeight: '2rem',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    color: theme.color.text_color.grey,
    textAlign: 'left',
    lineHeight: '1.08',
    padding: '0 0.25rem 0 0',
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    color: theme.color.text_color.black,
    textAlign: 'right',
    padding: '0 0 0 0.25rem',
    textOverflow: 'ellipsis',
    // display: "flex",
    // alignItems: "flex-end",
    lineHeight: '1.08',
  },
  external: {
    display: 'flex',
    minHeight: '2.813rem',
    // borderRadius: "0px 0px 12px 12px",
    background: '#fafafa',
  },
  externalHorizontal: {
    display: 'flex',
    minHeight: '2.5rem',
    background: theme.color.button.background_white,
    flexDirection: 'column',
    padding: '0 1rem',
    borderRadius: '0.375rem',
    margin: '0 0 1rem 0',
  },
  endBorderRadius: {
    borderRadius: '0 0 0.75rem 0.75rem',
  },
  externalButtonLeft: {
    borderRadius: '0rem 0rem 0rem 0.75rem',
  },
  externalButtonRight: {
    borderRadius: '0rem 0rem 0.75rem 0rem',
  },
  horizontalButton: {
    width: '100%',
    height: '2.8125rem',
    textAlign: 'center',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0rem',
    borderRadius: '0.375rem',
    border: '0rem',
  },
  horizontalButtonMore: {
    margin: '0.375rem 0 0 0',
    color: theme.color.button.text_black,
    backgroundColor: theme.color.button.background_grey,
  },
  horizontalButtonFirst: {
    color: theme.color.button.text_white,
    backgroundColor: theme.color.button.background_red,
  },
  horizontalButtonFirstDisabled: {
    color: theme.color.button.text_white_disable,
    backgroundColor: theme.color.button.background_red_disable,
  },
  horizontalButtonDisabled: {
    color: '#8f8f8f',
    backgroundColor: '#f7f7f7',
    // border: `solid 1px #999`,
    // display: 'none',
  },
  disabledButton: {
    color: 'rgba(38, 38, 38, 0.4)',
  },
  externalDivider: {
    // height: "1.25rem",
    alignSelf: 'center',
    backgroundColor: theme.color.divider,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  buttonIcon: {
    width: '1.25rem',
    height: '1.25rem',
    marginRight: '0.25rem',
  },
  horizontalButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0.5rem 1.125rem',
  },
  horizontalButtonLabel: {
    display: 'flex',
    flexDirection: 'row',
  },
  priceBox: {
    width: '-webkit-fill-available',
    margin: '0 1.25rem',
    padding: '0.625rem 0',
  },
  priceRow: {
    height: '100%',
    display: 'flex',
    alignItems: 'baseline',
  },
  priceTitle: {
    textAlign: 'left',
    fontSize: theme.font.size12,
    fontWeight: 'bold',
    color: theme.color.text_color.black,
  },
  priceMaster: {
    fontWeight: 'bold',
    fontSize: theme.font.size16,
    color: theme.color.text_color.black,
    // marginStart: "0.5rem",
    wordBreak: 'breakWord',
    lineHeight: '1.13',
  },
  priceDesc: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: theme.font.size12,
    color: theme.color.text_color.grey,
  },
  // priceMaster: {
  //   textDecoration: "line-through",
  //   fontSize: theme.font.size12,
  //   color: theme.color.text_color.price_na,
  //   margin: "0 0.25rem 0 0",
  //   // lineHeight: "1.08"
  //   // marginStart: "0.5rem",
  // },
  badge: {
    position: 'absolute',
    margin: '0.75rem',
    display: 'flex',
  },
  badgeIcon: {
    height: theme.font.size35,
  },
  badgeTitle: {
    color: '#ffffff',
    position: 'absolute',
    fontSize: theme.font.size13,
    fontWeight: 'bold',
    margin: '0.3125rem 0.625rem',
  },
  benefitsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    // padding: "0 1.25rem"
  },
  emptyBenefitsRow: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '1.1563rem',
    // minHeight: "6.25rem"
  },
  benefitsText: {
    fontSize: theme.font.size11,
    color: theme.color.text_color.black,
    lineHeight: '1.18',
    textAlign: 'left',
    alignItems: 'center',
  },
  benefitsInfoButton: {
    minWidth: '1rem',
    minHeight: '1rem',
    // objectFit: "contain",
    backgroundImage: `url(${IconInfo})`,
    backgroundColor: 'transparent',
    border: '0rem',
  },
  midButtonRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: '0 1.25rem 1.25rem 1.25rem',
    minHeight: '2.875rem',
  },
  midButtonBox: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '1',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    border: '0rem',
    backgroundColor: theme.color.button.background_white,
    padding: '0',
  },
  midButtonAdditional: {
    border: '0rem',
    backgroundColor: theme.color.button.background_white,
    padding: '0',
  },
  midButtonAddtionalOnly: {
    margin: '0 0 1.875rem 1rem',
  },
  midButtonText: {
    fontSize: theme.font.size12,
    color: theme.color.text_color.black,
    lineHeight: '1.25',
    margin: '0.3125rem 0 0 0',
  },
  midButtonTextAdditional: {
    textDecoration: 'underline',
    fontSize: theme.font.size12,
    color: theme.color.text_color.black,
    lineHeight: '1.33',
  },
  midButtonRowAddOnly: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    minHeight: '2.875rem',
    padding: '0 1.25rem 1.25rem 1.25rem',
  },
});

function HorizontalButtonRaw(props) {
  const { classes, data, handleClick } = props;
  const context = useContext(DataContext);
  const item = data;

  return (
    <div
      className={[
        classes.externalHorizontal,
        // classes.endBorderRadius,
      ].join(' ')}
    >
      {item.buttons.map((button, index) => {
        // console.log('button :::::::: ', button);

        const isButtonDisabled =
          // (context.userAgent.deviceType !== 'mobile' &&
          //   button.parameters.action === 'phone') ||
          context.conversationEnd || button.parameters.enable === 'N';

        return (
          <Fragment key={`horizontal_buttons${index}`}>
            {/* <Divider component={"div"} disabled /> */}
            <button
              type="button"
              className={[
                classes.horizontalButton,
                index === 0
                  ? classes.horizontalButtonFirst
                  : classes.horizontalButtonMore,
                // classes.endBorderRadius,
                isButtonDisabled &&
                  (index === 0
                    ? classes.horizontalButtonFirstDisabled
                    : classes.horizontalButtonDisabled),
              ].join(' ')}
              disabled={isButtonDisabled}
              onClick={() =>
                handleClick(
                  context.userAgent.deviceType === 'mobile'
                    ? // [개선] 모바일 "전화 상담 예약" > "전화 상담" 25-03
                      // ? button.parameters.mobile_url
                      // : button.parameters.url,
                      //   item.link.event_action.request_call_reservation_mobile_link_url
                      // : item.link.event_action.request_call_reservation_pc_link_url,
                      button.parameters.mobile_url
                    : item.link.event_action.request_call_reservation_pc_link_url,
                  button.parameters.action
                )
              }
            >
              {/* <div className={classes.horizontalButtonContainer}> */}
              {/* <div className={classes.horizontalButtonLabel}> */}
              {/* {button.label === context.string.chat.moreProducts && (
                  <img
                    className={classes.buttonIcon}
                    src={IconMore}
                    alt={"IconMore"}
                  />
                )} */}
              <div>{button.label}</div>
              {/* </div> */}
              {/* </div> */}
            </button>
          </Fragment>
        );
      })}
    </div>
  );
}

const HorizontalButton = withStyles(styles)(HorizontalButtonRaw);

const Card = React.forwardRef((props, ref) => {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const featureMoreItems = true;

  const handleClick = (url, action, event, button, item) => {
    if (!ref.clickAllowed()) {
      return;
    }

    if (button && button.type && button.type.toLowerCase() === 'speech') {
      context.request(context, item.link.product_name + ' ' + button.label, 'button');
    } else {
      openLink(context, action, url, event);
    }
  };

  let cardList = data.items.map((item, key) => (
    <div key={`cardList${key}`} className={classes.listitem}>
      <div className={classes.card}>
        <button
          className={classes.thumbnail}
          onClick={() =>
            handleClick(
              item.link['product_link_url'],
              item.link['type'],
              item.link?.event_action
            )
          }
        >
          <img
            className={classes.thumbnailImage}
            src={item.link['product_image_url']}
            alt={`${item.link['product_title']
              .replace('<sup>', '')
              .replace('</sup>', '')
              .replace('ThinQ', '씽큐')}, ${item.link['product_name']}, 상세 바로가기`}
          />
        </button>
        <div className={classes.info}>
          {/* HTML TAG가 들어간 경우 처리 */}
          <div
            className={classes.infoTitle}
            dangerouslySetInnerHTML={{ __html: item.link['product_title'] }}
            role={'text'}
          />
          <div
            className={classes.infoDescription}
            dangerouslySetInnerHTML={{ __html: item.link['product_name'] }}
          />
          <Divider
            orientation={'horizontal'}
            className={classes.horizontalDivider}
            component={'div'}
            disabled
          />
          <div className={classes.table} size="small">
            {item.product_spec.map((spec, key) => (
              <Fragment key={`spec_${key}`}>
                <Grid container className={classes.tableRow} key={`product_price${key}`}>
                  <Grid
                    item
                    xs={6}
                    className={classes.label}
                    dangerouslySetInnerHTML={{
                      __html: spec.label,
                    }}
                  />
                  <Grid
                    item
                    xs={6}
                    className={classes.value}
                    dangerouslySetInnerHTML={{
                      __html: spec.value,
                    }}
                  />
                </Grid>
              </Fragment>
            ))}
          </div>
          <Divider
            orientation={'horizontal'}
            className={classes.horizontalDivider}
            component={'div'}
            disabled
          />
          {item.product_price && (
            <Fragment>
              <div className={classes.priceBox} size="small">
                <Grid container className={classes.priceRow} key={`product_price${key}`}>
                  <Grid container xs={6}>
                    <div className={classes.priceTitle}>월</div>
                  </Grid>
                  <Grid
                    className={classes.priceMaster}
                    container
                    xs={6}
                    justifyContent="flex-end"
                    dangerouslySetInnerHTML={{
                      __html: `${item.product_price}원`,
                    }}
                    aria-label={`정상가: ${item.product_price}원`}
                    role="text"
                  />
                  {/* <div
                        className={classes.priceObs}
                        aria-label={`할인가: ${item.product_price_obs}원`}
                        role="text"
                      >{item.product_price_obs + "원"}</div> */}
                  <Grid
                    item
                    xs={12}
                    className={classes.priceDesc}
                    dangerouslySetInnerHTML={{
                      __html: item.product_price_desc,
                    }}
                    aria-label={`${item.product_price_desc}`}
                    role="text"
                  />
                </Grid>
              </div>
            </Fragment>
          )}
        </div>
        <Divider
          orientation={'horizontal'}
          className={classes.horizontalDivider}
          component={'div'}
          disabled
        />
        {item.buttons && <HorizontalButton data={item} handleClick={handleClick} />}
      </div>
    </div>
  ));
  if (featureMoreItems && data.more_items && data.more_items.enable === 'Y') {
    let moreitem_button = (
      <div className={classes.moreItemList}>
        <div
          className={classes.moreItemCard}
          onClick={() => handleClick(data.more_items.url, data.more_items.type)}
        >
          <div className={classes.moreItemThumbnailImage} />
          <div className={classes.moreItemText}>
            {context.string.chat.moreItemHomepage.split('\n').map((content, index) => (
              <Fragment key={`moreItem${index}`}>
                <span>{content}</span>
                <br />
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    );
    cardList.push(moreitem_button);
  }
  return cardList;
});

function CareCard(props) {
  const { classes, data } = props;

  return (
    <>
      <div className={classes.root}>
        <Carousel
          className={classes.carousel}
          component={withStyles(styles)(Card)}
          data={data}
        />
      </div>
    </>
  );
}
export default withStyles(styles)(CareCard);
